export default __webpack_public_path__ + "5ff3d60ede4554df20c1e4a6fec2c253.webp";